<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header
          v-if="this.isPreLoading()"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>hourglass_empty</md-icon>
          </div>
          <h4 class="title">Laden</h4>
        </md-card-header>
        <md-card-header
          v-if="!this.isPreLoading()"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>people</md-icon>
          </div>
          <h4 class="title">Verwijderde gebruikers</h4>
        </md-card-header>
        <md-card-content>
          <md-table
            v-if="this.tableData.length > 0"
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="sortAll"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Gebruikers per pagina</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Zoek gebruiker(s)"
                  v-model="searchQuery"
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Achternaam" md-sort-by="lastName">
                {{ item.lastName }}</md-table-cell
              >
              <md-table-cell
                md-label="Tussenvoegsel"
                md-sort-by="lastNamePrefix"
              >
                {{ item.lastNamePrefix }}</md-table-cell
              >
              <md-table-cell md-label="Voornaam" md-sort-by="firstName">
                {{ item.firstName }}</md-table-cell
              >
              <md-table-cell
                @click.native="handleMail(item)"
                md-label="Email"
                md-sort-by="email"
              >
                {{ item.email }}</md-table-cell
              >
              <md-table-cell md-label="Verwijderd op" md-sort-by="deleted_at">
                {{ item.deleted_at }}</md-table-cell
              >
              <md-table-cell md-label="Herstellen">
                <md-button
                  class="md-just-icon md-success md-simple"
                  @click.native="handleUndelete(item)"
                >
                  <md-icon>refresh</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div v-if="this.noResults()" class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th class="md-table-row">
                    <div class="md-table-cell-container md-ripple md-disabled">
                      <div class="md-table-head-label">
                        Geen verwijderde gebruikers gevonden.
                      </div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>
        <md-card-actions
          v-if="this.tableData.length > 0"
          md-alignment="space-between"
        >
          <div class="">
            <p class="card-category">
              Weergave van {{ from + 1 }} t/m {{ to }} van
              {{ total }} gebruikers
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      requesting: false,
      currentSort: "lastName",
      currentSortOrder: "asc",
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      searchQuery: "",
      propsToSearch: [
        "firstName",
        "lastNamePrefix",
        "lastNamePrefix",
        "email",
        "deleted_at"
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    isPreLoading() {
      return this.requesting && this.tableData.length === 0;
    },
    noResults() {
      return !this.requesting && this.tableData.length === 0;
    },
    loadUsers() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "users/deleted").then(
        response => {
          this.requesting = false;
          this.tableData = response.data.users;

          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].lastNamePrefix == null) {
              this.tableData[i].lastNamePrefix = "";
            }
          }

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableData, {
            keys: [
              "firstName",
              "lastNamePrefix",
              "lastName",
              "email",
              "deleted_at"
            ],
            threshold: 0.3
          });
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van gebruikers",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    getFullUserName(user, nbsp = false) {
      let name =
        user.firstName +
        " " +
        (user.lastNamePrefix != null && user.lastNamePrefix != ""
          ? user.lastNamePrefix + " "
          : "") +
        user.lastName;

      if (nbsp) {
        name = name.replace(" ", "&nbsp;");
      }

      return name;
    },
    handleMail(item) {
      window.location = "mailto:" + item.email;
    },
    handleUndelete(item) {
      Swal.fire({
        title: "Weet u het zeker?",
        text: `Gebruiker "${this.getFullUserName(
          item
        )}" wordt hersteld in het systeem.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Herstellen",
        cancelButtonText: "Annuleren",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$http
            .post(this.$apiBaseUrl + "users/" + item.id + "/undelete")
            .then(
              response => {
                this.deleteRow(item);

                this.notifyVue(
                  "Gebruiker succesvol hersteld",
                  "check",
                  "success",
                  5000
                );

                // Fuse search initialization.
                this.fuseSearch = new Fuse(this.tableData, {
                  keys: [
                    "firstName",
                    "lastNamePrefix",
                    "lastName",
                    "email",
                    "deleted_at"
                  ],
                  threshold: 0.3
                });
              },
              response => {
                if (response.status === 403) {
                  this.notifyVue(
                    "U heeft geen rechten voor het beheren van gebruikers",
                    "add_alert",
                    "danger",
                    0
                  );
                } else if (response.status === 422) {
                  this.notifyVue(
                    "U kunt uzelf niet herstellen",
                    "add_alert",
                    "danger",
                    0
                  );
                }
              }
            );
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  mounted() {
    this.loadUsers();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
